import React from "react"

export default function ButtonRefresh({ onClick }) {
  return (
    <button type="button" className="btn btn-tool" title="rafraîchir" onClick={onClick}>
      <i className="fas fa-sync-alt" />
    </button>
  )
}
